// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>22</span>&nbsp;&nbsp;I was but foolish and ignorant;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;I was like a brute beast in your presence.<br> </p> </div></div>";
// Exports
module.exports = code;